<app-header></app-header>
<app-toolbar></app-toolbar>
<app-breadcrumb></app-breadcrumb>
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
<app-footer></app-footer> 